import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { unitStats } from '../../../stats';

export const collegeReducer = (scratch: StatsSnapshot) => {
  const stats = unitStats.college;
  const generated = stats.buildingsGeneration ?? 0;

  scratch.generators.seminary.owned += generated;

  return;
};
